/**
 * Humanize a snake_case / SCREAMING_SNAKE / kebab key for display.
 * Replaces separators with spaces and preserves known acronym casing
 * (QA, ID, SLA, PO, ETA, KPI, BOM, CPA, ROI, URL).
 *
 * Example: humanizeStatus("qa_passed") → "QA passed"
 */
const ACRONYMS = ["QA", "ID", "SLA", "PO", "ETA", "KPI", "BOM", "CPA", "ROI", "URL"];

export function humanizeStatus(value: string | undefined | null): string {
  if (!value) return "";
  let out = String(value).replace(/[_-]+/g, " ").trim();
  for (const acronym of ACRONYMS) {
    out = out.replace(new RegExp(`\\b${acronym}\\b`, "gi"), acronym);
  }
  return out;
}